import React from "react";
import "../About/Aboutus.css";
import icon from '../../Assets/img/IconFounder.png';
const FounderPreview = ({ previewService, setShowPreviewFounder }) => {
    const s = previewService;
    if (!s) return null;

    return (
        <div className="fp-overlay" onClick={() => setShowPreviewFounder(false)}>
            <div className="fp-modal" onClick={(e) => e.stopPropagation()}>
                {/* Close Button */}
                <button className="fp-close" onClick={() => setShowPreviewFounder(false)}>
                    ✕
                </button>

                <div className="fp-wrapper">

                    {/* LEFT SIDE IMAGE SECTION */}
                    <div className="fp-left">

                        {/* CIRCLE IMAGE */}
                        <div className="fp-circle">
                            <img src={s.image} alt="Founder" className="fp-main-img" />
                        </div>

                        {/* COUNTRY BADGE */}
                        {s.flagImage && (
                            <div className="fp-flag-badge">
                                <img src={s.flagImage} alt="Flag" className="fp-flag-icon" />
                                <p>{s.flagTitle}</p>
                            </div>
                        )}
                        <div className="shadow-lg p-2 bg-white rounded-3 cardwidthandheights icon-left-center">
                            <img src={icon} alt="Icon" className="img-fluid" style={{ maxWidth: "60%" }} />
                            <h4 className="canadian mt-2">Canadian</h4>
                            <h4 className="canadian" >& Chadian</h4>

                        </div>
                        {/* EXPERIENCE BADGE */}
                        <div className="fp-exp-badge">
                            <h2>{s.experienceYears || "20+"}</h2>
                            <p>Years of International Experience</p>
                        </div>
                    </div>

                    {/* RIGHT SIDE CONTENT */}
                    <div className="fp-right">
                        <h1 className="fp-subtitle">{s.heading}</h1>
                        <h2 className="fp-title">{s.title}</h2>
                        <div
                            className="fp-description"
                            dangerouslySetInnerHTML={{ __html: s.description }}
                        />

                        {/* BOTTOM STATS */}
                        <div className="fp-stats">
                            {s.metricsData && s.metricsData.length > 0 && (
                                <>
                                    <div className="fp-stat-box">
                                        <h1>{s.metricsData[0].metrics_value}X</h1>
                                        <p>{s.metricsData[0].metrics}</p>
                                    </div>

                                    <div className="fp-stat-box">
                                        <h1>{s.metricsData[1].metrics_value}K</h1>
                                        <p>{s.metricsData[1].metrics}</p>
                                    </div>

                                    <div className="fp-stat-box">
                                        <h1>{s.metricsData[2].metrics_value}%</h1>
                                        <p>{s.metricsData[2].metrics}</p>
                                    </div>
                                </>
                            )}
                        </div>

                    </div>

                </div>
            </div>
        </div>
    );
};

export default FounderPreview;
